//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const CASES_API_BASE_URL = new InjectionToken<string>('CASES_API_BASE_URL');

export interface ICasesApiService {
    /**
     * Get the list of the customer's cases.
     * @param page (optional) 
     * @param size (optional) 
     * @param sort (optional) 
     * @param search (optional) 
     * @param caseTypeTags (optional) 
     * @param statuses (optional) 
     * @param caseTypeCodes (optional) 
     * @param createdFrom (optional) 
     * @param createdTo (optional) 
     * @param completedFrom (optional) 
     * @param completedTo (optional) 
     * @param checkpoints (optional) 
     * @param data (optional) 
     * @param metadata (optional) 
     * @param includeDrafts (optional) 
     * @param referenceNumbers (optional) 
     * @param includeData (optional) 
     * @return OK
     */
    getMyCasesExtention(page?: number | undefined, size?: number | undefined, sort?: string | undefined, search?: string | undefined, caseTypeTags?: string[] | undefined, statuses?: CaseStatus[] | undefined, caseTypeCodes?: string[] | undefined, createdFrom?: Date | undefined, createdTo?: Date | undefined, completedFrom?: Date | undefined, completedTo?: Date | undefined, checkpoints?: string[] | undefined, data?: string[] | undefined, metadata?: string[] | undefined, includeDrafts?: boolean | undefined, referenceNumbers?: number[] | undefined, includeData?: boolean | undefined): Observable<MyCasePartialResultSet>;
    /**
     * Create a new draft case.
     * @return OK
     */
    createDraftCaseExtention(caseId: string): Observable<Case>;
    /**
     * Get case details by Id.
     * @return OK
     */
    getMyCaseByIdExtention(caseId: string): Observable<Case>;
    /**
     * Update the case with the business data as defined at the specific case type.
     * @return No Content
     */
    updateCaseExtention(caseId: string, body: UpdateCaseRequest): Observable<void>;
    /**
     * Add an attachment to an existing case regardless of its status and mode (draft or not).
     * @param file (optional) 
     * @return OK
     */
    uploadCaseAttachmentExtention(caseId: string, file?: FileParameter | undefined): Observable<CasesAttachmentLink>;
    /**
     * Submit the case by removing the draft mode.
     * @return No Content
     */
    submitMyCaseExtention(caseId: string): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class CasesApiService implements ICasesApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CASES_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Get the list of the customer's cases.
     * @param page (optional) 
     * @param size (optional) 
     * @param sort (optional) 
     * @param search (optional) 
     * @param caseTypeTags (optional) 
     * @param statuses (optional) 
     * @param caseTypeCodes (optional) 
     * @param createdFrom (optional) 
     * @param createdTo (optional) 
     * @param completedFrom (optional) 
     * @param completedTo (optional) 
     * @param checkpoints (optional) 
     * @param data (optional) 
     * @param metadata (optional) 
     * @param includeDrafts (optional) 
     * @param referenceNumbers (optional) 
     * @param includeData (optional) 
     * @return OK
     */
    getMyCasesExtention(page?: number | undefined, size?: number | undefined, sort?: string | undefined, search?: string | undefined, caseTypeTags?: string[] | undefined, statuses?: CaseStatus[] | undefined, caseTypeCodes?: string[] | undefined, createdFrom?: Date | undefined, createdTo?: Date | undefined, completedFrom?: Date | undefined, completedTo?: Date | undefined, checkpoints?: string[] | undefined, data?: string[] | undefined, metadata?: string[] | undefined, includeDrafts?: boolean | undefined, referenceNumbers?: number[] | undefined, includeData?: boolean | undefined): Observable<MyCasePartialResultSet> {
        let url_ = this.baseUrl + "/api/my-cases?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (size === null)
            throw new Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "Size=" + encodeURIComponent("" + size) + "&";
        if (sort === null)
            throw new Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (caseTypeTags === null)
            throw new Error("The parameter 'caseTypeTags' cannot be null.");
        else if (caseTypeTags !== undefined)
            caseTypeTags && caseTypeTags.forEach(item => { url_ += "CaseTypeTags=" + encodeURIComponent("" + item) + "&"; });
        if (statuses === null)
            throw new Error("The parameter 'statuses' cannot be null.");
        else if (statuses !== undefined)
            statuses && statuses.forEach(item => { url_ += "Statuses=" + encodeURIComponent("" + item) + "&"; });
        if (caseTypeCodes === null)
            throw new Error("The parameter 'caseTypeCodes' cannot be null.");
        else if (caseTypeCodes !== undefined)
            caseTypeCodes && caseTypeCodes.forEach(item => { url_ += "CaseTypeCodes=" + encodeURIComponent("" + item) + "&"; });
        if (createdFrom === null)
            throw new Error("The parameter 'createdFrom' cannot be null.");
        else if (createdFrom !== undefined)
            url_ += "CreatedFrom=" + encodeURIComponent(createdFrom ? "" + createdFrom.toISOString() : "") + "&";
        if (createdTo === null)
            throw new Error("The parameter 'createdTo' cannot be null.");
        else if (createdTo !== undefined)
            url_ += "CreatedTo=" + encodeURIComponent(createdTo ? "" + createdTo.toISOString() : "") + "&";
        if (completedFrom === null)
            throw new Error("The parameter 'completedFrom' cannot be null.");
        else if (completedFrom !== undefined)
            url_ += "CompletedFrom=" + encodeURIComponent(completedFrom ? "" + completedFrom.toISOString() : "") + "&";
        if (completedTo === null)
            throw new Error("The parameter 'completedTo' cannot be null.");
        else if (completedTo !== undefined)
            url_ += "CompletedTo=" + encodeURIComponent(completedTo ? "" + completedTo.toISOString() : "") + "&";
        if (checkpoints === null)
            throw new Error("The parameter 'checkpoints' cannot be null.");
        else if (checkpoints !== undefined)
            checkpoints && checkpoints.forEach(item => { url_ += "Checkpoints=" + encodeURIComponent("" + item) + "&"; });
        if (data === null)
            throw new Error("The parameter 'data' cannot be null.");
        else if (data !== undefined)
            data && data.forEach(item => { url_ += "Data=" + encodeURIComponent("" + item) + "&"; });
        if (metadata === null)
            throw new Error("The parameter 'metadata' cannot be null.");
        else if (metadata !== undefined)
            metadata && metadata.forEach(item => { url_ += "Metadata=" + encodeURIComponent("" + item) + "&"; });
        if (includeDrafts === null)
            throw new Error("The parameter 'includeDrafts' cannot be null.");
        else if (includeDrafts !== undefined)
            url_ += "IncludeDrafts=" + encodeURIComponent("" + includeDrafts) + "&";
        if (referenceNumbers === null)
            throw new Error("The parameter 'referenceNumbers' cannot be null.");
        else if (referenceNumbers !== undefined)
            referenceNumbers && referenceNumbers.forEach(item => { url_ += "ReferenceNumbers=" + encodeURIComponent("" + item) + "&"; });
        if (includeData === null)
            throw new Error("The parameter 'includeData' cannot be null.");
        else if (includeData !== undefined)
            url_ += "IncludeData=" + encodeURIComponent("" + includeData) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyCasesExtention(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyCasesExtention(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MyCasePartialResultSet>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MyCasePartialResultSet>;
        }));
    }

    protected processGetMyCasesExtention(response: HttpResponseBase): Observable<MyCasePartialResultSet> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MyCasePartialResultSet.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create a new draft case.
     * @return OK
     */
    createDraftCaseExtention(caseId: string): Observable<Case> {
        let url_ = this.baseUrl + "/api/my-cases?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDraftCaseExtention(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDraftCaseExtention(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Case>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Case>;
        }));
    }

    protected processCreateDraftCaseExtention(response: HttpResponseBase): Observable<Case> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Case.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get case details by Id.
     * @return OK
     */
    getMyCaseByIdExtention(caseId: string): Observable<Case> {
        let url_ = this.baseUrl + "/api/my-cases/{caseId}";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyCaseByIdExtention(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyCaseByIdExtention(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Case>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Case>;
        }));
    }

    protected processGetMyCaseByIdExtention(response: HttpResponseBase): Observable<Case> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Case.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update the case with the business data as defined at the specific case type.
     * @return No Content
     */
    updateCaseExtention(caseId: string, body: UpdateCaseRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/my-cases/{caseId}";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCaseExtention(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCaseExtention(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateCaseExtention(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add an attachment to an existing case regardless of its status and mode (draft or not).
     * @param file (optional) 
     * @return OK
     */
    uploadCaseAttachmentExtention(caseId: string, file?: FileParameter | undefined): Observable<CasesAttachmentLink> {
        let url_ = this.baseUrl + "/api/my-cases/{caseId}/attachments";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadCaseAttachmentExtention(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadCaseAttachmentExtention(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CasesAttachmentLink>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CasesAttachmentLink>;
        }));
    }

    protected processUploadCaseAttachmentExtention(response: HttpResponseBase): Observable<CasesAttachmentLink> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CasesAttachmentLink.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Submit the case by removing the draft mode.
     * @return No Content
     */
    submitMyCaseExtention(caseId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/my-cases/{caseId}/submit";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmitMyCaseExtention(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmitMyCaseExtention(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSubmitMyCaseExtention(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class AuditMeta implements IAuditMeta {
    id?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;
    when?: Date | undefined;

    constructor(data?: IAuditMeta) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.when = _data["when"] ? new Date(_data["when"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AuditMeta {
        data = typeof data === 'object' ? data : {};
        let result = new AuditMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["email"] = this.email;
        data["when"] = this.when ? this.when.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAuditMeta {
    id?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;
    when?: Date | undefined;
}

export class Case implements ICase {
    id?: string;
    referenceNumber?: number | undefined;
    ownerId?: string | undefined;
    ownerName?: string | undefined;
    ownerTin?: string | undefined;
    userId?: string | undefined;
    createdByWhen?: Date | undefined;
    createdById?: string | undefined;
    createdByEmail?: string | undefined;
    createdByName?: string | undefined;
    caseType?: CaseTypePartial;
    metadata?: { [key: string]: string; } | undefined;
    groupId?: string | undefined;
    checkpointType?: CheckpointType;
    data?: any | undefined;
    assignedToName?: string | undefined;
    channel?: string | undefined;
    draft?: boolean;
    accessLevel?: number;
    attachments?: CaseAttachment[] | undefined;
    approvers?: AuditMeta[] | undefined;

    constructor(data?: ICase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.referenceNumber = _data["referenceNumber"];
            this.ownerId = _data["ownerId"];
            this.ownerName = _data["ownerName"];
            this.ownerTin = _data["ownerTin"];
            this.userId = _data["userId"];
            this.createdByWhen = _data["createdByWhen"] ? new Date(_data["createdByWhen"].toString()) : <any>undefined;
            this.createdById = _data["createdById"];
            this.createdByEmail = _data["createdByEmail"];
            this.createdByName = _data["createdByName"];
            this.caseType = _data["caseType"] ? CaseTypePartial.fromJS(_data["caseType"]) : <any>undefined;
            if (_data["metadata"]) {
                this.metadata = {} as any;
                for (let key in _data["metadata"]) {
                    if (_data["metadata"].hasOwnProperty(key))
                        (<any>this.metadata)![key] = _data["metadata"][key];
                }
            }
            this.groupId = _data["groupId"];
            this.checkpointType = _data["checkpointType"] ? CheckpointType.fromJS(_data["checkpointType"]) : <any>undefined;
            this.data = _data["data"];
            this.assignedToName = _data["assignedToName"];
            this.channel = _data["channel"];
            this.draft = _data["draft"];
            this.accessLevel = _data["accessLevel"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(CaseAttachment.fromJS(item));
            }
            if (Array.isArray(_data["approvers"])) {
                this.approvers = [] as any;
                for (let item of _data["approvers"])
                    this.approvers!.push(AuditMeta.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Case {
        data = typeof data === 'object' ? data : {};
        let result = new Case();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["referenceNumber"] = this.referenceNumber;
        data["ownerId"] = this.ownerId;
        data["ownerName"] = this.ownerName;
        data["ownerTin"] = this.ownerTin;
        data["userId"] = this.userId;
        data["createdByWhen"] = this.createdByWhen ? this.createdByWhen.toISOString() : <any>undefined;
        data["createdById"] = this.createdById;
        data["createdByEmail"] = this.createdByEmail;
        data["createdByName"] = this.createdByName;
        data["caseType"] = this.caseType ? this.caseType.toJSON() : <any>undefined;
        if (this.metadata) {
            data["metadata"] = {};
            for (let key in this.metadata) {
                if (this.metadata.hasOwnProperty(key))
                    (<any>data["metadata"])[key] = (<any>this.metadata)[key];
            }
        }
        data["groupId"] = this.groupId;
        data["checkpointType"] = this.checkpointType ? this.checkpointType.toJSON() : <any>undefined;
        data["data"] = this.data;
        data["assignedToName"] = this.assignedToName;
        data["channel"] = this.channel;
        data["draft"] = this.draft;
        data["accessLevel"] = this.accessLevel;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        if (Array.isArray(this.approvers)) {
            data["approvers"] = [];
            for (let item of this.approvers)
                data["approvers"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICase {
    id?: string;
    referenceNumber?: number | undefined;
    ownerId?: string | undefined;
    ownerName?: string | undefined;
    ownerTin?: string | undefined;
    userId?: string | undefined;
    createdByWhen?: Date | undefined;
    createdById?: string | undefined;
    createdByEmail?: string | undefined;
    createdByName?: string | undefined;
    caseType?: CaseTypePartial;
    metadata?: { [key: string]: string; } | undefined;
    groupId?: string | undefined;
    checkpointType?: CheckpointType;
    data?: any | undefined;
    assignedToName?: string | undefined;
    channel?: string | undefined;
    draft?: boolean;
    accessLevel?: number;
    attachments?: CaseAttachment[] | undefined;
    approvers?: AuditMeta[] | undefined;
}

export class CaseAttachment implements ICaseAttachment {
    id?: string;
    fileName?: string | undefined;
    contentType?: string | undefined;
    fileExtension?: string | undefined;
    data?: string | undefined;

    constructor(data?: ICaseAttachment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileName = _data["fileName"];
            this.contentType = _data["contentType"];
            this.fileExtension = _data["fileExtension"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): CaseAttachment {
        data = typeof data === 'object' ? data : {};
        let result = new CaseAttachment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileName"] = this.fileName;
        data["contentType"] = this.contentType;
        data["fileExtension"] = this.fileExtension;
        data["data"] = this.data;
        return data;
    }
}

export interface ICaseAttachment {
    id?: string;
    fileName?: string | undefined;
    contentType?: string | undefined;
    fileExtension?: string | undefined;
    data?: string | undefined;
}

export enum CaseStatus {
    Submitted = "Submitted",
    InProgress = "InProgress",
    Completed = "Completed",
    Deleted = "Deleted",
}

export class CaseTypePartial implements ICaseTypePartial {
    id?: string;
    code?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    dataSchema?: any | undefined;
    layout?: any | undefined;
    layoutTranslations?: { [key: string]: string; } | undefined;
    tags?: string | undefined;
    config?: any | undefined;
    order?: number | undefined;
    canCreateRoles?: string[] | undefined;
    category?: Category;
    translations?: { [key: string]: CaseTypeTranslation; } | undefined;
    isMenuItem?: boolean;
    gridFilterConfig?: any | undefined;
    gridColumnConfig?: any | undefined;

    constructor(data?: ICaseTypePartial) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.dataSchema = _data["dataSchema"];
            this.layout = _data["layout"];
            if (_data["layoutTranslations"]) {
                this.layoutTranslations = {} as any;
                for (let key in _data["layoutTranslations"]) {
                    if (_data["layoutTranslations"].hasOwnProperty(key))
                        (<any>this.layoutTranslations)![key] = _data["layoutTranslations"][key];
                }
            }
            this.tags = _data["tags"];
            this.config = _data["config"];
            this.order = _data["order"];
            if (Array.isArray(_data["canCreateRoles"])) {
                this.canCreateRoles = [] as any;
                for (let item of _data["canCreateRoles"])
                    this.canCreateRoles!.push(item);
            }
            this.category = _data["category"] ? Category.fromJS(_data["category"]) : <any>undefined;
            if (_data["translations"]) {
                this.translations = {} as any;
                for (let key in _data["translations"]) {
                    if (_data["translations"].hasOwnProperty(key))
                        (<any>this.translations)![key] = _data["translations"][key] ? CaseTypeTranslation.fromJS(_data["translations"][key]) : new CaseTypeTranslation();
                }
            }
            this.isMenuItem = _data["isMenuItem"];
            this.gridFilterConfig = _data["gridFilterConfig"];
            this.gridColumnConfig = _data["gridColumnConfig"];
        }
    }

    static fromJS(data: any): CaseTypePartial {
        data = typeof data === 'object' ? data : {};
        let result = new CaseTypePartial();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["title"] = this.title;
        data["description"] = this.description;
        data["dataSchema"] = this.dataSchema;
        data["layout"] = this.layout;
        if (this.layoutTranslations) {
            data["layoutTranslations"] = {};
            for (let key in this.layoutTranslations) {
                if (this.layoutTranslations.hasOwnProperty(key))
                    (<any>data["layoutTranslations"])[key] = (<any>this.layoutTranslations)[key];
            }
        }
        data["tags"] = this.tags;
        data["config"] = this.config;
        data["order"] = this.order;
        if (Array.isArray(this.canCreateRoles)) {
            data["canCreateRoles"] = [];
            for (let item of this.canCreateRoles)
                data["canCreateRoles"].push(item);
        }
        data["category"] = this.category ? this.category.toJSON() : <any>undefined;
        if (this.translations) {
            data["translations"] = {};
            for (let key in this.translations) {
                if (this.translations.hasOwnProperty(key))
                    (<any>data["translations"])[key] = this.translations[key] ? this.translations[key].toJSON() : <any>undefined;
            }
        }
        data["isMenuItem"] = this.isMenuItem;
        data["gridFilterConfig"] = this.gridFilterConfig;
        data["gridColumnConfig"] = this.gridColumnConfig;
        return data;
    }
}

export interface ICaseTypePartial {
    id?: string;
    code?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    dataSchema?: any | undefined;
    layout?: any | undefined;
    layoutTranslations?: { [key: string]: string; } | undefined;
    tags?: string | undefined;
    config?: any | undefined;
    order?: number | undefined;
    canCreateRoles?: string[] | undefined;
    category?: Category;
    translations?: { [key: string]: CaseTypeTranslation; } | undefined;
    isMenuItem?: boolean;
    gridFilterConfig?: any | undefined;
    gridColumnConfig?: any | undefined;
}

export class CaseTypeTranslation implements ICaseTypeTranslation {
    title?: string | undefined;
    description?: string | undefined;

    constructor(data?: ICaseTypeTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CaseTypeTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new CaseTypeTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        return data;
    }
}

export interface ICaseTypeTranslation {
    title?: string | undefined;
    description?: string | undefined;
}

export class CasesAttachmentLink implements ICasesAttachmentLink {
    id?: string;
    fileGuid?: string;
    permaLink?: string | undefined;
    label?: string | undefined;
    size?: number;
    readonly sizeText?: string | undefined;
    contentType?: string | undefined;

    constructor(data?: ICasesAttachmentLink) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileGuid = _data["fileGuid"];
            this.permaLink = _data["permaLink"];
            this.label = _data["label"];
            this.size = _data["size"];
            (<any>this).sizeText = _data["sizeText"];
            this.contentType = _data["contentType"];
        }
    }

    static fromJS(data: any): CasesAttachmentLink {
        data = typeof data === 'object' ? data : {};
        let result = new CasesAttachmentLink();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileGuid"] = this.fileGuid;
        data["permaLink"] = this.permaLink;
        data["label"] = this.label;
        data["size"] = this.size;
        data["sizeText"] = this.sizeText;
        data["contentType"] = this.contentType;
        return data;
    }
}

export interface ICasesAttachmentLink {
    id?: string;
    fileGuid?: string;
    permaLink?: string | undefined;
    label?: string | undefined;
    size?: number;
    sizeText?: string | undefined;
    contentType?: string | undefined;
}

export class Category implements ICategory {
    id?: string;
    name?: string | undefined;
    description?: string | undefined;
    order?: number | undefined;
    translations?: { [key: string]: CategoryTranslation; } | undefined;

    constructor(data?: ICategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.order = _data["order"];
            if (_data["translations"]) {
                this.translations = {} as any;
                for (let key in _data["translations"]) {
                    if (_data["translations"].hasOwnProperty(key))
                        (<any>this.translations)![key] = _data["translations"][key] ? CategoryTranslation.fromJS(_data["translations"][key]) : new CategoryTranslation();
                }
            }
        }
    }

    static fromJS(data: any): Category {
        data = typeof data === 'object' ? data : {};
        let result = new Category();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["order"] = this.order;
        if (this.translations) {
            data["translations"] = {};
            for (let key in this.translations) {
                if (this.translations.hasOwnProperty(key))
                    (<any>data["translations"])[key] = this.translations[key] ? this.translations[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface ICategory {
    id?: string;
    name?: string | undefined;
    description?: string | undefined;
    order?: number | undefined;
    translations?: { [key: string]: CategoryTranslation; } | undefined;
}

export class CategoryTranslation implements ICategoryTranslation {
    name?: string | undefined;
    description?: string | undefined;

    constructor(data?: ICategoryTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CategoryTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}

export interface ICategoryTranslation {
    name?: string | undefined;
    description?: string | undefined;
}

export class CheckpointType implements ICheckpointType {
    id?: string;
    code?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    status?: CaseStatus;
    private?: boolean | undefined;
    translations?: { [key: string]: CheckpointTypeTranslation; } | undefined;

    constructor(data?: ICheckpointType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.status = _data["status"];
            this.private = _data["private"];
            if (_data["translations"]) {
                this.translations = {} as any;
                for (let key in _data["translations"]) {
                    if (_data["translations"].hasOwnProperty(key))
                        (<any>this.translations)![key] = _data["translations"][key] ? CheckpointTypeTranslation.fromJS(_data["translations"][key]) : new CheckpointTypeTranslation();
                }
            }
        }
    }

    static fromJS(data: any): CheckpointType {
        data = typeof data === 'object' ? data : {};
        let result = new CheckpointType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["title"] = this.title;
        data["description"] = this.description;
        data["status"] = this.status;
        data["private"] = this.private;
        if (this.translations) {
            data["translations"] = {};
            for (let key in this.translations) {
                if (this.translations.hasOwnProperty(key))
                    (<any>data["translations"])[key] = this.translations[key] ? this.translations[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface ICheckpointType {
    id?: string;
    code?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    status?: CaseStatus;
    private?: boolean | undefined;
    translations?: { [key: string]: CheckpointTypeTranslation; } | undefined;
}

export class CheckpointTypeTranslation implements ICheckpointTypeTranslation {
    title?: string | undefined;
    description?: string | undefined;

    constructor(data?: ICheckpointTypeTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CheckpointTypeTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new CheckpointTypeTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        return data;
    }
}

export interface ICheckpointTypeTranslation {
    title?: string | undefined;
    description?: string | undefined;
}

export class HttpValidationProblemDetails implements IHttpValidationProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    errors?: { [key: string]: string[]; } | undefined;

    [key: string]: any;

    constructor(data?: IHttpValidationProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (<any>this.errors)![key] = _data["errors"][key] !== undefined ? _data["errors"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): HttpValidationProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new HttpValidationProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (<any>data["errors"])[key] = (<any>this.errors)[key];
            }
        }
        return data;
    }
}

export interface IHttpValidationProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    errors?: { [key: string]: string[]; } | undefined;

    [key: string]: any;
}

export class MyCasePartial implements IMyCasePartial {
    id?: string;
    referenceNumber?: number | undefined;
    created?: Date | undefined;
    caseTypeCode?: string | undefined;
    title?: string | undefined;
    checkpointType?: CheckpointType;
    metadata?: { [key: string]: string; } | undefined;
    message?: string | undefined;
    translations?: { [key: string]: CaseTypeTranslation; } | undefined;
    data?: any | undefined;

    constructor(data?: IMyCasePartial) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.referenceNumber = _data["referenceNumber"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.caseTypeCode = _data["caseTypeCode"];
            this.title = _data["title"];
            this.checkpointType = _data["checkpointType"] ? CheckpointType.fromJS(_data["checkpointType"]) : <any>undefined;
            if (_data["metadata"]) {
                this.metadata = {} as any;
                for (let key in _data["metadata"]) {
                    if (_data["metadata"].hasOwnProperty(key))
                        (<any>this.metadata)![key] = _data["metadata"][key];
                }
            }
            this.message = _data["message"];
            if (_data["translations"]) {
                this.translations = {} as any;
                for (let key in _data["translations"]) {
                    if (_data["translations"].hasOwnProperty(key))
                        (<any>this.translations)![key] = _data["translations"][key] ? CaseTypeTranslation.fromJS(_data["translations"][key]) : new CaseTypeTranslation();
                }
            }
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): MyCasePartial {
        data = typeof data === 'object' ? data : {};
        let result = new MyCasePartial();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["referenceNumber"] = this.referenceNumber;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["caseTypeCode"] = this.caseTypeCode;
        data["title"] = this.title;
        data["checkpointType"] = this.checkpointType ? this.checkpointType.toJSON() : <any>undefined;
        if (this.metadata) {
            data["metadata"] = {};
            for (let key in this.metadata) {
                if (this.metadata.hasOwnProperty(key))
                    (<any>data["metadata"])[key] = (<any>this.metadata)[key];
            }
        }
        data["message"] = this.message;
        if (this.translations) {
            data["translations"] = {};
            for (let key in this.translations) {
                if (this.translations.hasOwnProperty(key))
                    (<any>data["translations"])[key] = this.translations[key] ? this.translations[key].toJSON() : <any>undefined;
            }
        }
        data["data"] = this.data;
        return data;
    }
}

export interface IMyCasePartial {
    id?: string;
    referenceNumber?: number | undefined;
    created?: Date | undefined;
    caseTypeCode?: string | undefined;
    title?: string | undefined;
    checkpointType?: CheckpointType;
    metadata?: { [key: string]: string; } | undefined;
    message?: string | undefined;
    translations?: { [key: string]: CaseTypeTranslation; } | undefined;
    data?: any | undefined;
}

export class MyCasePartialResultSet implements IMyCasePartialResultSet {
    count?: number;
    items?: MyCasePartial[] | undefined;

    constructor(data?: IMyCasePartialResultSet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MyCasePartial.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MyCasePartialResultSet {
        data = typeof data === 'object' ? data : {};
        let result = new MyCasePartialResultSet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMyCasePartialResultSet {
    count?: number;
    items?: MyCasePartial[] | undefined;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class UpdateCaseRequest implements IUpdateCaseRequest {
    data?: any | undefined;

    constructor(data?: IUpdateCaseRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): UpdateCaseRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCaseRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data;
        return data;
    }
}

export interface IUpdateCaseRequest {
    data?: any | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}